import { render, staticRenderFns } from "./editar-recurso-acessibilidade.vue?vue&type=template&id=1c7551f5&"
import script from "./editar-recurso-acessibilidade.vue?vue&type=script&lang=ts&"
export * from "./editar-recurso-acessibilidade.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c7551f5')) {
      api.createRecord('1c7551f5', component.options)
    } else {
      api.reload('1c7551f5', component.options)
    }
    module.hot.accept("./editar-recurso-acessibilidade.vue?vue&type=template&id=1c7551f5&", function () {
      api.rerender('1c7551f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recurso-acessibilidade/editar-recurso-acessibilidade.vue"
export default component.exports